<template>
	<div class='lg-interest' v-if="status">
		<div class="container">
			<div class="title">
				<p class="lg-list-title">你可能感兴趣的课程领域</p>
				<i class="el-icon-close" @click="handleCloseInterest"/>
			</div>
			<div class="interest-list">
				<div class="list">
					<span :class="tags.indexOf(item.id.toString()) !== -1 ? 'list-item  list-item_active':'list-item'" v-for="(item,index) in interest_list" :key="index" @click="handleSelectInterest(item)">{{item.name}}</span>
				</div>
			</div>
			<div class="interest-selected">
				<p class="lg-list-title">已选{{select_list.length}}个</p>
				<div class="selected-list">
					<el-tag
						v-for="tag in select_list"
						:key="tag.id"
						closable
						@close="handleClose(tag)"
					>
						{{tag.name}}
					</el-tag>
				</div>
			</div>
			<div class="interest-bottom">
				<button @click="handleSubmit">保存</button>
				<button @click="handleCloseInterest">取消</button>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        /* 是否打开 */
        status:false,
        /* 兴趣列表 */
        interest_list:[],
        /* 已选列表 */
        select_list:[],
        /* 提交数据标签列表 */
        tags:[],
      }
    },
    created() {
      this.$requestApi.video.videoCategory().then(res => this.interest_list = res.data)
      this.$Bus.$off('interest_open').$on('interest_open',value => this.status = true)
    },
    methods: {
      handleSelectInterest(data){
        if (this.tags.indexOf(data.id.toString()) !== -1){
          this.tags.splice(this.tags.indexOf(data.id.toString()),1)
          this.select_list.map((item,index) =>{
            item.id === data.id ? this.select_list.splice(index,1):''
          })
        } else {
          this.tags.push(data.id.toString())
          this.select_list.push({
            id:data.id,
            name:data.name
          })
        }
      },
      /* 已选标签关闭 */
      handleClose(data){
        this.tags.splice(this.tags.indexOf(data.id.toString()),1)
        this.select_list.map((item,index) =>{
          item.id === data.id ? this.select_list.splice(index,1):''
        })
      },
      /* 关闭弹框 */
      handleCloseInterest(){
        this.select_list = []
        this.tags = []
        this.status = false
        location.reload()
      },
      /* 保存标签 */
      handleSubmit(){
		this.$requestApi.api.interest_put({'tags':this.tags}).then(res =>{
		  this.handleCloseInterest()
		})
      }
    }
  }
</script>

<style scoped lang='less'>
.lg-interest{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2000;
	display: flex;
	align-items: center;
	justify-content: center;
	.container{
		background-color: #ffffff;
		width: 894px;
		height: auto;
		border-radius: 8px;
		padding: 20px;
		box-sizing: border-box;
		.title{
			display: flex;
			align-items: center;
			justify-content: space-between;
			/deep/ .el-icon-close{
				font-size: 20px;
				cursor: pointer;
			}
		}
		.interest-list{
			.list{
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				&-item{
					padding: 8px 20px;
					background-color: #f4f4f4;
					border-radius: 4px;
					color: #666666;
					font-size: 14px;
					margin-top: 20px;
					margin-right: 20px;
					cursor: pointer;
				}
				&-item_active,&-item:hover{
					background-color: #FFDE00;
					color: #ffffff;
				}
			}
		}
		.interest-selected{
			margin-top: 20px;

			.selected-list{
				min-height: 200px;
				max-height: 250px;
				overflow-y: scroll;
				/deep/ .el-tag{
					color: #ffffff;
					background-color: #FFDE00;
					border: none;
					margin-top: 20px;
					margin-right: 20px;
					padding: 8px 20px;
					height: auto;
					line-height: normal;
					font-size: 14px;
					.el-tag__close{
						color: #ffffff;
					}
					.el-tag__close:hover{
						background-color: #ffffff;
						color: #333333;
					}
				}
			}
		}
		.interest-bottom{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 20px;
			button{
				width: 120px;
				height: 35px;
				line-height: 33px;
				font-size: 16px;
				border-radius: 6px;
			}
			button:first-child{
				background-color: #FFDE00;
				color: #ffffff;
				margin-right: 20px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/interest/index.vue